// extracted by mini-css-extract-plugin
module.exports = {"container":"resultReport_container__2TX8M"};